import type { DirectorSkillSummary } from '../../api/directorSkills'

/** Immutable binding plus inline display metadata for a pending first turn. */
export type DirectorSkillSelection = Pick<
  DirectorSkillSummary, 'ref' | 'versionId' | 'name' | 'publicSlug' | 'displayName'
> & { position: number }

/** Navigation state is untrusted; never degrade a malformed binding to text. */
export function directorSkillSelectionFromState(
  value: object | null | undefined,
  key: string,
): DirectorSkillSelection | undefined {
  const raw = value && Object.entries(value).find(([field]) => field === key)?.[1]
  if (raw === undefined || raw === null) return undefined
  if (typeof raw !== 'object' || Array.isArray(raw)) {
    throw new Error('Invalid pending Director skill selection')
  }
  const fields = Object.fromEntries(Object.entries(raw))
  const { ref, versionId, name, publicSlug, displayName, position } = fields
  if (typeof ref !== 'string' || !ref || typeof versionId !== 'string' || !versionId
    || typeof name !== 'string' || !name || typeof displayName !== 'string' || !displayName
    || typeof position !== 'number' || !Number.isInteger(position) || position < 0) {
    throw new Error('Pending Director skill selection requires immutable ref, versionId and inline position')
  }
  return {
    ref,
    versionId,
    name,
    publicSlug: typeof publicSlug === 'string' && publicSlug ? publicSlug : name,
    displayName,
    position,
  }
}
